
<template>
  <div>
  
  <Mainlayout></Mainlayout>

    <CJumbotron
      class="d-sm-down-none"
      style="background-size: cover; color: #fff"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <CContainer>
        <CRow>
          <CCol
            sm="12"
            lg="12"
            style="margin-bottom:10%"
            class="element-50 mt-5 text-left custom-center-pro"
          >
            <div>
              <h1
                style="font-weight: 600; margin-top: 10%;"
                class="display-1 text-white custom-font"
              >
                <strong>About Pickiddo</strong>
              </h1>

              <h6 style="line-height:2em;font-size:20px" class="display-6 text-white custom-font">
                Pickiddo is a platform to manage online tuition by providing
                on-demand tuition services<br /> 
                 to those who want to learn from the 
                best teachers anywhere in the world interactively.
              </h6>
            </div>
          </CCol>
        </CRow>
      </CContainer>
    </CJumbotron>



    <CJumbotron
      class="d-md-none mb-0"
      style="background-size: cover; color: #fff"
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <CContainer>
        <CRow>
          <CCol
            sm="12"
            lg="12"
            class="element-50 mt-5 text-left custom-center-pro"
          >
            <div>
              <!-- <h1 style="font-weight: 400" class="display-1 text-white">
                <strong>Be our partner and earn more</strong>
              </h1> -->
              <h1
                style="font-weight: 400;margin-top: 10%"
                class="display-5 text-white d-md-none custom-font"
              >
                <strong>About Pickiddo</strong>
              </h1>

              <h5 style="font-size:15px" class="display-5 text-white custom-font">
                Pickiddo is a platform to manage online tuition by providing
                on-demand tuition services to those who want to learn from the
                best teachers anywhere in the world interactively.
              </h5>
            </div>

            <br /><br />
            <br /><br />
          </CCol>
        </CRow>
      </CContainer>
    </CJumbotron>

   

    <CCol sm="12" lg="12">
      <CRow class="mt-3 mb-5">
        <CCol sm="6" lg="6">
          <br />
          <h3 class="mt-5 ml-5 display-3 custom-font">
            <span style="font-weight: 700"> Who's Our Tutor</span>
          </h3>
          <h5 style="line-height: 2em" class="ml-5 mb-5 display-6 custom-font">
            Pickiddo provide the best tutor for you to gain better study
            experience. We will make sure that student can focussed perfectly
            based on capability of the student.
          </h5>
          <CButton color="info" class="ml-5">REGISTER AS TUTOR</CButton>
        </CCol>
        <CCol sm="6" lg="6">
          <br /><br /><br />
          <CRow class="p-0 m-0">
            <CCol sm="4" class="p-0 m-0">
              
                <div style="text-align: center">
                  <img
                    style="max-width: 200px"
                    src="../assets/img/teacher1.png"
                  />
                </div>
            </CCol>
            <CCol sm="4" class="p-0 m-0">
              
                <div style="text-align: center">
                  <img
                    style="max-width: 200px"
                    src="../assets/img/teacher2.png"
                  />
                </div>
            </CCol>
            <CCol sm="4" class="p-0 m-0">
             
                <div style="text-align: center">
                  <img
                    style="max-width: 200px"
                    src="../assets/img/teacher3.png"
                  />
                </div>
            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </CCol>

    <CCol
      style="background-size: cover; color: #fff"
      :style="{ backgroundImage: `url(${backgroundLearn})` }"
      sm="12"
      lg="12"
    >
      <CRow>
        <CContainer>
          <CCard color="primary" class="mt-5">
            <h3 class="mt-5 ml-5 display-4 custom-font text-white">
              <span style="font-weight: 700"> Our Mission & Vision</span>
            </h3>

            <h5 class="mt-2 ml-5 display-5 custom-font text-white">
              Our Vision
            </h5>
            <h6 style="line-height:2em" class="mt-2 ml-5 custom-font text-white mr-5">
            To be recognised in this region with the best learning experience platform and empowers students to achieve their academic and personal goals.
            </h6>

            <h5 class="mt-4 ml-5 display-5 custom-font text-white">
              Our Mission
            </h5>
            <h6 style="line-height:2em" class="mt-2 ml-5 mb-5 custom-font text-white mr-5">
            To provide students with opportunities to increase and enhance their achievement in academic skills and abilities through cultivating effective learning practices.
            </h6>
          </CCard>
        </CContainer>
      </CRow>
    </CCol>

    <CCol sm="12" lg="12">
       <h3 class="mt-5 ml-5 display-4 text-center custom-font">
            <span style="font-weight: 700"> Our Feedback</span>
          </h3>

          <div class="text-center mt-5">
            <img style="max-width:100%" src="../assets/img/feedback1.png" />
          </div>
    </CCol>

    <CCol sm="12" lg="12">
      <CRow>
        <CContainer>
          <h3 class="mt-5 ml-5 display-4 text-center custom-font">
            <span style="font-weight: 700"> Follow Us</span>
          </h3>

          <h5 class="mt-2 ml-5 display-6 custom-font text-center">
            Get our latest update Pickiddo by our social media
          </h5>
          <div class="text-center mt-5 mb-5">
            <a href="https://www.facebook.com/pickiddo">
              <img width="60px" src="../assets/img/fb1.png" />
            </a>
            <a href="https://twitter.com/pickiddo?lang=en">
              <img width="60px" class="ml-1" src="../assets/img/twgrey.png" />
            </a>
          </div>
        </CContainer>
      </CRow>
    </CCol>

    <div style="background: #f1efef">
      <CContainer>
        <CCol sm="12" lg="12" class="p-5">
          <CRow>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">PREFACE</h5>
              <br />
              <label class="custom-font"
                >Pickiddo is a platform to manage online tuition by providing
                on-demand tuition services to those who want to learn from the
                best teachers anywhere in the world interactively. It has
                leading-edge features that can speed up the job matching process
                and it's powered by A.I.</label
              >
              <a href="https://www.facebook.com/pickiddo">
                <img width="30px" src="../assets/img/fb1.png" />
              </a>
              <a href="https://twitter.com/pickiddo?lang=en">
                <img width="30px" class="ml-1" src="../assets/img/tw.png" />
              </a>
              <a href="https://www.instagram.com/pickiddo/?hl=en">
                <img width="30px" class="ml-1" src="../assets/img/in.png" />
              </a>
              <br /><br />
            </CCol>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">
                <strong> COMPANY </strong>
              </h5>
              <br />
               <br />
                <a>
                <CHeaderNavLink to="/About">
                  <h6 class="text-black custom-font">ABOUT US</h6></CHeaderNavLink
                >
              </a>
              <br />
               <a>
                <CHeaderNavLink to="/Contact">
                  <h6 class="text-black custom-font">CONTACT US</h6></CHeaderNavLink
                >
              </a>
              <br />
              <!-- <a href="https://pickiddo.com/Blog"
                ><h6 class="text-black custom-font">BLOG</h6></a
              > -->
              <br /><br />
            </CCol>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">
                <strong>COMMUNITY</strong>
              </h5>
              <br />
              <a href="https://www.facebook.com/pickiddo"
                ><h6 class="text-black custom-font">FACEBOOK</h6></a
              >
              <br />
              <a href="https://twitter.com/pickiddo?lang=en">
                <h6
                  class="text-black custom-font"
                  href="https://twitter.com/pickiddo?lang=en"
                >
                  TWITTER
                </h6>
              </a>
              <br />
              <a href="https://www.instagram.com/pickiddo/?hl=en">
                <h6 class="text-black custom-font">INSTAGRAM</h6>
              </a>
              <br /><br />
            </CCol>
            <CCol sm="3" lg="3">
              <h5 class="titleFooter text-black custom-font">
                <strong>TERM PRIVACY</strong>
              </h5>
              <br />
              <a>
                <CHeaderNavLink to="/Legal">
                  <h6 class="text-black custom-font">TERMS AND CONDITION</h6></CHeaderNavLink
                >
              </a>
            </CCol>
          </CRow>
        </CCol>
      </CContainer>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

import backgroundUrl from "../assets/img/bgSkill.png";
import backgroundBanner from "../assets/img/edu.jpg";
import backgroundBannerUrl from "../assets/img/bg4.png";
import backgroundBannerReg from "../assets/img/bgReg.jpg";
import backgroundUrlNews from "../assets/img/update.jpg";
import backgroundUrlContact from "../assets/img/bgcontact.png";
import backgroundLearn from "../assets/img/bgLearn.png";

import Mainlayout from "../containers/AllHeaderLanding.vue";

import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "ProClass",
  components: {
    Mainlayout
  },
  data() {
    return {
      backgroundUrl,
      backgroundBanner,
      backgroundBannerUrl,
      backgroundBannerReg,
      backgroundUrlNews,
      backgroundUrlContact,
      backgroundLearn,

      // Name,
      // PhoneNumber,
      // Email,
      // Message,
    };
  },
  created() {
    AOS.init();
 
  },
  mounted() {
   this.$forceUpdate();
  },
  methods: {
    InsertPartner() {
      const formData = new FormData();

      formData.append("Name", this.Name);
      formData.append("Email", this.Email);
      formData.append("PhoneNumber", this.PhoneNumber);
      formData.append("Message", this.Message);

      return this.$API
        .post(this.$RegisterPartner, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.$dialog
              .alert("You have successfully save data")
              .then(function (dialog) {
                console.log("Closed");
              });
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Error";
          }
        });
    },
     
  },
};
</script>

<style>
body {
  background: #fff;
}
.carousel-indicators li {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #000015;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  -webkit-transition: opacity 0.6s ease;
  transition: opacity 0.6s ease;
}

.custom-font {
  font-family: "Rubik", sans-serif;
}

.change_color {
  background-color: red;
}

* {
  padding: 0;
  margin: 0;
}

body {
  height: 100vh;
}
body nav {
  position: fixed;
  width: 100%;
  height: 70px;
  background-color: transparent;
  display: flex;
  align-items: center;
  transition: all 0.2s ease-in-out;
}
body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}

.c-header {
  background: rgb(23, 77, 124);
  background: linear-gradient(92deg, #174d7c, #1b7682);
  border-bottom: 0.01px solid #1a6783;
  border-bottom: 1px solid #636f83;
  /* color: #fff; */
}

@import url("https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap");
</style>

